<form
  (ngSubmit)="handleSubmit()"
  [formGroup]="form"
  autocomplete="off"
  class="flex flex-col justify-center w-full m-auto px-6 py-8 lg:py-11 md:max-w-[70%]"
  data-test-id="reset-form">
  <span class="lg:text-2xl lg:leading-10 font-medium">PIN Reset</span>
  <span class="mb-7 lg:mb-[53px] mt-2.5 leading-7 font-light">We’ll send you a verification code via SMS</span>
  <div class="w-full mb-3">
    <bey-country-phone-number-input
      formControlName="phone"
      label="Phone number"
      [options]="countries"
      getElementId
      [control]="form.controls['phone']"></bey-country-phone-number-input>
  </div>

  <bey-button
    placeholder="Submit"
    classList="px-12 w-full"
    [submit]="true"
    [disabled]="form.invalid"
    [isLoading]="sendVerificationCodeIsLoading$ | async"
    getElementId
    getElementIdDescription="submit"></bey-button>

  <!-- signup is disabled for now, TODO: remove this when signup is enabled -->
  <!-- <div class="font-semibold text-base text-gray-900 text-center mt-16" data-test-id="cta-signup">
    Don't have an account?
    <a class="text-blue-400" routerLink="/signup">Sign up</a>
  </div> -->

  <div class="text-center mt-12">
    <a class="text-blue-400 text-base font-medium" routerLink="/login" data-test-id="back-login">Back to Login</a>
  </div>
</form>
